interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="w-9 h-9 rounded-md border border-background-200 bg-background-50 flex items-center justify-center text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? 'page' : undefined}
          className={`min-w-9 h-9 px-2 rounded-md text-sm font-label transition-colors cursor-pointer ${
            item === page
              ? 'bg-primary-500 text-background-50 font-bold'
              : 'border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="w-9 h-9 rounded-md border border-background-200 bg-background-50 flex items-center justify-center text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}